module.exports = __webpack_public_path__ + "static/media/LIV_BlackLogo.d85409b5.svg";